import { makeStyles } from 'tss-react/mui';

const useStylesTable: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme, props: MaterialUIStylesProps,
): MaterialUIStyles => ({
  table: {
    minWidth: props.minWidth || '100%',
  },
  tableFullWidth: {
    width: '100% !important',
  },
}));

export default useStylesTable;
